export default __webpack_public_path__ + "static/media/star.c8953ca2.svg";